module.exports = __webpack_public_path__ + "img/bdt.52c42f37.png";